import React, { useEffect, useState } from 'react';
import { agentApi } from '../../services/agentApi';
import { card } from './agentUi';

type MailboxInfo = Awaited<ReturnType<typeof agentApi.mailboxes>>;

/** The company's Arie mailbox address and how to use it. */
const MailboxCard: React.FC = () => {
  const [info, setInfo] = useState<MailboxInfo | null>(null);
  const [copied, setCopied] = useState<string | null>(null);

  useEffect(() => {
    agentApi.mailboxes().then(setInfo).catch(() => setInfo(null));
  }, []);

  const copy = (address: string) => {
    navigator.clipboard?.writeText(address).then(() => {
      setCopied(address);
      setTimeout(() => setCopied(null), 1500);
    });
  };

  return (
    <div className={`${card} p-4`}>
      <h3 className="text-sm font-semibold text-gray-900 dark:text-white">Your company's Arie mailbox</h3>
      {!info ? (
        <p className="text-sm text-gray-500 mt-2">Loading…</p>
      ) : info.mailboxes.length === 0 ? (
        <p className="text-sm text-gray-500 mt-2">Your company doesn't have an Arie mailbox yet. Contact RiskNinja support to get one set up.{info.transport === 'none' ? ' (Local stack: use “Simulate an email” instead.)' : ''}</p>
      ) : (
        <>
          <ul className="mt-2 space-y-1.5">
            {info.mailboxes.map((m) => (
              <li key={m.id} className="flex items-center gap-2">
                <code className="text-sm bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-gray-100 px-2 py-1 rounded">{m.address}</code>
                <button className="text-xs text-primary hover:underline" onClick={() => copy(m.address)}>{copied === m.address ? 'Copied' : 'Copy'}</button>
                {m.status !== 'active' && <span className="text-xs text-amber-600">{m.status}</span>}
              </li>
            ))}
          </ul>
          {!info.platformEnabled && <p className="text-xs text-amber-700 dark:text-amber-300 mt-2">The agent is currently switched off platform-wide; email sent now is held.</p>}
        </>
      )}
      {info && info.mailboxes.length > 0 && (
      <div className="mt-4 text-sm text-gray-700 dark:text-gray-200 space-y-2">
        <p><strong>How to use it:</strong> send or forward an email to this address from the address on your RiskNinja account. Say what you want in your own words above any forwarded message, for example “here are Acme's renewal docs, run the year-over-year” or “draft a reply to the underwriter”. Arie files the attachments, does the work and emails you a summary with links and the finished reports attached.</p>
        <p className="text-xs text-gray-500">Forwarding from a different address? Add it as a verified forwarding address below. Messages up to {info?.maxMessageMb || 150} MB; larger files belong in an in-app upload.</p>
      </div>
      )}
    </div>
  );
};

export default MailboxCard;
